import { render, staticRenderFns } from "./norms.vue?vue&type=template&id=51f8ee31&scoped=true&"
import script from "./norms.vue?vue&type=script&lang=js&"
export * from "./norms.vue?vue&type=script&lang=js&"
import style0 from "./norms.vue?vue&type=style&index=0&id=51f8ee31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8ee31",
  null
  
)

export default component.exports